import Request from '../Request.utils'
export interface ICreateRequestBody {
  despatchNoteNo: string;
  type?: 'initial_print' | 'reprint';
}
export interface IDetailRequestParams {
  jobId: string;
}
export interface IRetryRequestParams {
  jobId: string;
}


class LabelPrintJobAPI {
  create = async (body: ICreateRequestBody) => {
    const res = await Request.call('/api/label-print-jobs', 'POST', undefined, undefined, body, );
    return res;
  }
  detail = async (params: IDetailRequestParams) => {
    const res = await Request.call('/api/label-print-jobs/:jobId', 'GET', params, undefined, undefined, );
    return res;
  }
  retry = async (params: IRetryRequestParams) => {
    const res = await Request.call('/api/label-print-jobs/:jobId/retry', 'POST', params, undefined, undefined, );
    return res;
  }
}
export default new LabelPrintJobAPI()